import { render, staticRenderFns } from "./status-chip.vue?vue&type=template&id=59e0ec7a"
import script from "./status-chip.vue?vue&type=script&lang=js"
export * from "./status-chip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports